<template>
  <div class="location-map-viewer">
    <template v-if="showLocation && location">
      <div class="location-map-viewer__marker">
        <SVGIcon
          :iconName="'place'"
          :width="'28px'"
          :height="'28px'"
        />
      </div>
      <div class="location-map-viewer__coordinates">
        <span>{{ location.lat }}</span>
        <span>{{ location.lon }}</span>
      </div>
    </template>
    <div v-else class="location-map-viewer__empty">
      No location data
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import SVGIcon from '@/components/SVGIcon.vue';

const props = defineProps({
  imageObj: {
    type: Object,
    default: () => ({}),
  },
  annotations: {
    type: Array,
    default: () => [],
  },
  showLocation: {
    type: Boolean,
    default: false,
  },
});

const location = computed(() => {
  const gps = props.imageObj?.meta?.gps || props.imageObj?.gps || props.imageObj?.metadata?.gps;
  const lat = gps?.lat ?? gps?.latitude ?? props.imageObj?.lat ?? props.imageObj?.latitude;
  const lon = gps?.lon ?? gps?.lng ?? gps?.longitude ?? props.imageObj?.lon ?? props.imageObj?.lng ?? props.imageObj?.longitude;

  if (lat === undefined || lon === undefined) {
    return null;
  }

  return { lat, lon };
});
</script>

<style lang="scss" scoped>
.location-map-viewer {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  height: 100%;
  min-height: 180px;
  background: #ffffff;
  color: var(--color-black);
}

.location-map-viewer__marker {
  color: var(--color-primary);
}

.location-map-viewer__coordinates {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: monospace;
  font-size: 0.85rem;
}

.location-map-viewer__empty {
  font-size: 0.9rem;
  color: var(--color-gray-700, #666666);
}
</style>